import { Button, Col, Image, Row, Tag } from 'antd';
import { ClickableProps, DataViewProps } from '../common/DataView';
import { AdapterDef } from '../../apis/mgmt/api';
import { CopyFilled, CopyOutlined } from '@ant-design/icons';


export const AdapterDefCard = function ( props:
    DataViewProps<AdapterDef> & ClickableProps<AdapterDef>
) {
    const data = props.data;
    const onClick = () => { data && props.onClick && props.onClick(data); }

    const sidePanelVisible = false; // props.sidePanelVisible || false; // TODO Get from context
    const sizes = sidePanelVisible? { xxl: 8, xl: 12, lg: 24 } : { xxl: 4, xl: 6, lg: 8, md: 12, sm: 24 };

    return data && (
        <Col key={data.id} style={{width: '24em'}}> {/* TODO {...sizes} */}

            <div className={'mig-card mig-card-content pointer'} onClick={onClick}>
                <div style={{width: "50px"}}>
                    <Image width="100%" preview={false} src={`/media/${data.platformDomain?.platform?.slug}.svg`} />
                </div><div style={{width: "calc(100% - 50px)"}}>
                    <span className='mig-title-3'>{data.name}</span>
                    <br/>
                    <small><small>{data.id}</small></small><Button type="link" onClick={
                            (e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                let previous = e.currentTarget.previousSibling;
                                previous && previous.textContent && navigator.clipboard.writeText(previous.textContent);
                            }
                        }
                    ><CopyOutlined /></Button>
                </div>
            </div>
        </Col>

    ) || null;
}
